import React from "react";
import { MessageWithActionAndData } from "@me8eon/sessions_messages";
import { NexthinkHealthCheck } from "./healthcheck.component";
import { NexthinkReportAndActions } from "./report.and.actions.component";
import { NexthinkActionStatus } from "./action.status.component";
import { NexthinkStateProvider } from "./nexthink.context";
import "../../../../modules/AiWidgets/nexthink/nexthinkActions.component.scss";

const NexthinkSmartActions: React.FC<MessageWithActionAndData> = (messageAndData) => {
    return (
        <NexthinkStateProvider messageAndData={messageAndData}>
            <div className="nexthink-smart-actions">
                <NexthinkHealthCheck/>
                <NexthinkReportAndActions/>
                <NexthinkActionStatus/>
            </div>
        </NexthinkStateProvider>
    );
};

export default NexthinkSmartActions;
